function getPathStyles(
  offset,
  percent,
  strokeColor,
  strokeWidth,
  gapPosition,
  gapDegree = 0
) {
  const radius = 50 - strokeWidth / 2;
  let beginPositionX = 0;
  let beginPositionY = -radius;
  let endPositionX = 0;
  let endPositionY = -2 * radius;

  switch (gapPosition) {
    case "left":
      beginPositionX = -radius;
      beginPositionY = 0;
      endPositionX = 2 * radius;
      endPositionY = 0;
      break;
    case "right":
      beginPositionX = radius;
      beginPositionY = 0;
      endPositionX = -2 * radius;
      endPositionY = 0;
      break;
    case "bottom":
      beginPositionY = radius;
      endPositionY = 2 * radius;
      break;
    default:
  }
  const pathString = `M 50,50 m ${beginPositionX},${beginPositionY}
   a ${radius},${radius} 0 1 1 ${endPositionX},${-endPositionY}
   a ${radius},${radius} 0 1 1 ${-endPositionX},${endPositionY}`;
  const len = Math.PI * 2 * radius;

  const pathStyle = {
    // Stroke: typeof strokeColor === "string" && strokeColor
    transition:
      "stroke-dashoffset .3s ease 0s, stroke-dasharray .3s ease 0s, stroke .3s, stroke-width .06s ease .3s, opacity .3s ease 0s",
    ...(typeof strokeColor === "string" && { stroke: strokeColor }),
    strokeDashoffset: `-${
      gapDegree / 2 + (offset / 100) * (len - gapDegree)
    }px`,
    strokeDasharray: `${(percent / 100) * (len - gapDegree)}px ${len}px`,
  };

  return {
    pathStyle,
    pathString,
  };
}

const Circle = ({
  id,
  prefixCls,
  strokeWidth,
  trailWidth,
  gapDegree,
  gapPosition,
  trailColor,
  strokeLinecap,
  style,
  className,
  strokeColor,
  percent,
  text,
  ...restProps
}) => {
  const { pathString, pathStyle } = getPathStyles(
    0,
    100,
    trailColor,
    strokeWidth,
    gapDegree,
    gapPosition
  );

  const getStokeList = () => {
    let stackPtg = 0;
    const stroke = "";
    const pathStyles = getPathStyles(
      stackPtg,
      percent,
      strokeColor,
      strokeWidth,
      gapDegree,
      gapPosition
    );

    stackPtg += percent;

    return (
      <path
        className={`${prefixCls}-circle-path`}
        d={pathStyles.pathString}
        stroke={stroke}
        strokeLinecap={strokeLinecap}
        strokeWidth={strokeWidth}
        opacity={percent === 0 ? 0 : 1}
        fillOpacity="0"
        style={pathStyles.pathStyle}
      />
    );
  };

  return (
    <>
      <svg
        className={`${prefixCls}-circle ${className}`}
        viewBox="0 0 100 100"
        style={style}
        id={id}
        {...restProps}
      >
        <path
          className={`${prefixCls}-circle-trail`}
          d={pathString}
          stroke={trailColor}
          strokeLinecap={strokeLinecap}
          strokeWidth={trailWidth || strokeWidth}
          fillOpacity="0"
          style={pathStyle}
        />
        {getStokeList()}
        {text && (
          <text
            className="text-base font-semibold"
            style={{
              dominantBaseline: "middle",
              textAnchor: "middle",
            }}
            x={50}
            y={50}
          >
            {text}
          </text>
        )}
      </svg>
    </>
  );
};

Circle.defaultProps = {
  trailWidth: 1,
  trailColor: "#E5E5E5",
  style: {},
  strokeWidth: 1,
  strokeLinecap: "round",
  strokeColor: "#007EFF",
  prefixCls: "rc-progress",
  percent: 0,
  className: "",
};

export default Circle;
